import {HostBinding, Input} from '@angular/core';

export abstract class AbstractInjection {
    @HostBinding('class.loaded') @Input() public loaded: boolean;
}
